<template>
	<button
		class="bg-fill-secondary flex w-full items-center gap-4 rounded-xl py-0.5 pr-4.5 pl-0.5"
		v-hover="hover"
	>
		<div
			class="bg-fill-tertiary relative flex h-19.5 w-19.5 shrink-0 items-center justify-center overflow-hidden rounded-[10px]"
		>
			<MethodBg
				class="absolute top-0 right-0 bottom-0 left-0"
				:style="{ color }"
			/>
			<div class="relative *:h-9 *:w-9">
				<slot />
			</div>
		</div>
		<div class="w-full flex-1">
			<div class="text-label-primary truncate text-left text-sm font-medium">
				{{ name }}
			</div>
			<div
				class="text-label-tertiary mt-1 truncate text-left text-sm capitalize"
			>
				{{ desc }}
			</div>
		</div>
		<CaretRightIcon class="text-label-tertiary h-5 w-5 shrink-0" v-if="!soon" />
		<div
			class="text-label-tertiary shrink-0 text-sm font-medium uppercase"
			v-else
		>
			{{ t('soon') }}
		</div>
	</button>
</template>
<script setup lang="ts">
import CaretRightIcon from '@/assets/icons/caret-right.svg'
import MethodBg from '@/assets/icons/method-bg.svg'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n({
	messages: {
		en: {
			soon: 'soon'
		},
		ru: {
			soon: 'скоро'
		}
	}
})

const props = defineProps<{
	color: string
	name: string
	desc: string
	soon?: boolean
}>()

const hover = computed(() =>
	props.soon ? { active: 'scale-100' } : { active: 'scale-95' }
)
</script>
